import { THumanResourcesFilters } from '../../components/HumanResources/human-resources';

export type GeographicSearchField = 'citta' | 'provincia';

export const buildGeographicFilterUpdate = (field: GeographicSearchField, value: string) => {
  const normalizedValue = value.trim();

  return field === 'provincia'
    ? { residenza: undefined, provincia: normalizedValue.toUpperCase() }
    : { residenza: normalizedValue, provincia: undefined };
};

export const normalizeHumanResourcesFilters = (
  filters: THumanResourcesFilters,
): THumanResourcesFilters => {
  const normalized = { ...filters };
  const province = filters.provincia?.trim();

  if (province) {
    normalized.provincia = province.toUpperCase();
    normalized.residenza = undefined;
  } else if (filters.residenza?.trim()) {
    normalized.residenza = filters.residenza.trim();
    normalized.provincia = undefined;
  } else {
    normalized.residenza = undefined;
    normalized.provincia = undefined;
  }

  return normalized;
};

export const getActiveGeographicSearch = (filters: THumanResourcesFilters) => {
  if (filters.provincia) {
    return { field: 'provincia' as const, value: filters.provincia };
  }

  return { field: 'citta' as const, value: filters.residenza || '' };
};
